import React from 'react';
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormControl,
  RadioGroup,
  Radio,
  TextField,
  Grid,
} from '@material-ui/core';
import { IntlShape, injectIntl } from 'react-intl';
import { isNil } from 'lodash';
import { Typography } from '@material-ui/core';
import { CHOICE } from 'containers/PreOpeningPage/constants';
import CloseIcon from '@material-ui/icons/Close';
import { StyledDialog } from 'components/InvoiceFeeNoteDialog/styles';
import { translate } from 'containers/services/translate';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import messages from 'containers/PreOpeningPage/messages';

export interface EligibilityTransactionDialogProps {
  intl: IntlShape;
  open: boolean;
  onClose: Function;
  eligible: any;
  setEligible: Function;
  handleValidate: Function;
  reason: any;
  setReason: Function;
}
const styledTitle = {
  color: '#172C51 !important',
  fontSize: '20px',
  lineHeight: '24.42px',
};
const styledChoice = {
  display: 'flex',
  justifyContent: 'space-around',
  marginTop: 15,
};
const styledGrid = { marginTop: 20, width: '60%' };
const styledTextField = {
  width: '100%',
};
const EligibilityTransactionDialog: React.FC<EligibilityTransactionDialogProps> = (
  props,
): JSX.Element => {
  const { onClose, open } = props;
  const handleClose = () => {
    onClose(false);
  };
  const handleChange = (
    event: React.ChangeEvent<{
      name?: string;
      value?: unknown;
    }>,
  ) => {
    props.setEligible(event.target.value);
  };
  const handleChangeField = (
    event: React.ChangeEvent<{
      name?: string;
      value?: unknown;
    }>,
  ) => {
    props.setReason(event.target.value);
  };
  return (
    <StyledDialog onClose={handleClose} open={open}>
      <DialogTitle>
        <Grid
          container
          direction="row"
          alignItems="center"
          justify="space-between"
        >
          <Grid item xs={9}>
            <span style={styledTitle}>
              {translate(messages.eligibilityButtonTitle, props)}
            </span>
          </Grid>
          <Grid item>
            <CloseIcon onClick={handleClose} />
          </Grid>
        </Grid>
      </DialogTitle>

      <DialogContent>
        <Typography className="success-title">
          {translate(messages.subTitleDialog, props)}
        </Typography>
        <FormControl style={styledChoice}>
          <RadioGroup row onChange={handleChange} value={props.eligible}>
            <FormControlLabel
              control={<Radio color="primary" value={CHOICE.YES} />}
              label={translate(messages.yesChoiceTitle, props)}
            />
            <FormControlLabel
              control={<Radio color="primary" value={CHOICE.NO} />}
              label={translate(messages.noChoiceTitle, props)}
            />
          </RadioGroup>
        </FormControl>
        <Grid style={styledGrid}>
          {props.eligible === CHOICE.NO && (
            <TextField
              name="reason"
              value={props.reason}
              onChange={handleChangeField}
              label={'Motif'}
              style={styledTextField}
            />
          )}
        </Grid>
      </DialogContent>
      <DialogActions className="success-actions">
        <SecondaryButton
          onClick={() => props.onClose()}
          disableElevation
          data-testId="cancel-button"
          title={translate(messages.cancel, props)}
        />
        <PrimaryButton
          onClick={() => props.handleValidate()}
          disableElevation
          data-testId="validate-button"
          className="primary-button"
          title={translate(messages.confirm, props)}
          disabled={
            isNil(props.eligible) ||
            (props.eligible === CHOICE.NO && isNil(props.reason))
          }
        />
      </DialogActions>
    </StyledDialog>
  );
};

export default injectIntl(EligibilityTransactionDialog);
